import { Box, Button, Dialog, DialogTitle, Divider, Grid } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";

export default function IdealTimerDialog({
openDialog,
handleClose,
handleLogOut,
remainingTime,
}) {
  useEffect(() => {
    const handler = function (e) {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, []);

  return (
  
     
     <div>
     <Dialog
       open={openDialog}
       onClose={handleClose}
       aria-labelledby="alert-dialog-title"
       aria-describedby="alert-dialog-description"
     >
       <DialogTitle id="alert-dialog-title"
        sx={{
         backgroundColor: "#003f93",
         color: "#ffffff",
         fontSize: "16px",
       }}>
         <Box sx={{ display: "flex", justifyContent: "space-between" }}>
           <div> Session Logout Timer</div>
           <GridCloseIcon
             className="pageHeader"
             onClick={handleClose}
             style={{ cursor: "pointer", color: "white" }}
           />
         </Box>
       </DialogTitle>
       <Divider />
       <Grid container className="bg-white">
         <Grid item xs={12} md={12}>
           <Grid item xs={12} md={12} sx={{ p: 3 }}>
             <Box><h5 style={{color: "#567aac",fontSize: "19px",
    marginBottom: "5px"}}>Are you there ?</h5> 
             <p style={{fontSize: "15px"}}>If not , your session will expire due to in-activity in {remainingTime} seconds.</p>
             </Box>
           </Grid>
           <Divider />
           <React.Fragment>
             <Box
               sx={{display: "flex", flexDirection: "row",alignItems:"flex-end", p: 1.5, pl: 23}}
             >
                <Box sx={{ flex: "1 1 auto" }} />
               <Button
                 variant="outlined"
                 onClick={handleClose}
                 sx={{ mr: 1}}
                 style={{ marginLeft: "auto" }}
                 autoFocus
               >
                Resume
               </Button>
               <Button 
                 type="submit"
               onClick={handleLogOut}
                 sx={{ mr: 1 }}
                 variant="contained"
                 className="button-primary-alt-contained"
                 style={{ marginLeft: "auto" }}
               >
               LOGOUT
               </Button>
              
             </Box>
           </React.Fragment>
         </Grid>
       </Grid>
     </Dialog>
   </div>
  );
}


